export default __webpack_public_path__ + "static/media/shanmukh.5e5aec37.jpg";